import React from 'react';
import { Button, FloatingMenu } from '@nicheinc/campus-ds';

import { TableMapperType } from '../../types';

type PropsType = {
	item: any;
	mapperField: TableMapperType;
};

function IconButtonCell({ item, mapperField }: PropsType) {
	const iconButtonMapperField = mapperField.iconButton;

	const menuItems =
		typeof iconButtonMapperField?.menuItems === 'function'
			? iconButtonMapperField?.menuItems(item)
			: iconButtonMapperField?.menuItems;

	if (!menuItems) {
		return (
			<Button
				variant={iconButtonMapperField?.variant || 'outlined'}
				iconButton
				disabled={iconButtonMapperField?.disabled}
				size={iconButtonMapperField?.size || 'medium'}
				icon={iconButtonMapperField?.iconName || 'cube'}
				onClick={() => {
					if (iconButtonMapperField?.onIconButtonClick) {
						iconButtonMapperField?.onIconButtonClick(item);
					}
				}}
			/>
		);
	}

	return (
		<FloatingMenu
			menus={menuItems ? [{ menuItems }] : []}
			closeOnSelect
			disabled={iconButtonMapperField?.disabled}
			trigger={
				<Button
					ariaLabel={`Open ${item?.name} menu`}
					variant={iconButtonMapperField?.variant || 'outlined'}
					iconButton
					disabled={iconButtonMapperField?.disabled}
					size={iconButtonMapperField?.size || 'medium'}
					icon={iconButtonMapperField?.iconName || 'cube'}
					onClick={() => {
						if (iconButtonMapperField?.onIconButtonClick) {
							iconButtonMapperField?.onIconButtonClick(item);
						}
					}}
				/>
			}
			itemCallbackData={item}
		/>
	);
}

export default IconButtonCell;
